// ✅ GLOBAL FUNCTION (same as yours)
window.checkCartLimit = function (limit = 4) {
  return fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      return {
        allowed: cart.item_count < limit,
        count: cart.item_count
      };
    })
    .catch((e) => {
      console.error('Cart fetch error:', e);
      return { allowed: false, count: 0 };
    });
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.continueSubmit(evt);
      }

      continueSubmit(evt) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        const mainId = formData.get('id');
        const comboId = this.form.querySelector('[name="combo_product_id"]')?.value;

        let items = [{ id: mainId, quantity: 1 }];

        if (comboId) {
          items.push({ id: comboId, quantity: 1 });
        }

        // ✅ Check cart limit properly
        window.checkCartLimit(4).then((result) => {

          if ((result.count + items.length) > 4) {
            this.showLimitPopup('You can only add maximum 4 items to cart');
            this.stopLoading();
            return;
          }

          // ✅ Add both items (MAIN + COMBO)
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          })
            .then(() => {
              if (this.cart) {
                return fetch('/cart.js')
                  .then(res => res.json())
                  .then(cart => {
                    this.cart.renderContents(cart);
                  });
              } else {
                window.location = '/cart';
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.stopLoading();
            });
        });
      }

      stopLoading() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showLimitPopup(message) {
        let popup = document.querySelector('.cart-limit-popup');

        if (!popup) {
          popup = document.createElement('div');
          popup.className = 'cart-limit-popup';
          document.body.appendChild(popup);
        }

        popup.textContent = message;
        popup.classList.add('active');

        setTimeout(() => {
          popup.classList.remove('active');
        }, 3000);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}